import React, { useContext } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { AppContext } from "../context/AppContext";
import CustomSidebar from "../components/Sidebar";
import HeaderContent from "../components/HeaderContent";

const { Header, Content } = Layout;

const MainLayout = () => {
  const { isDark } = useContext(AppContext);

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <CustomSidebar />
      <Layout>
        <Header
          style={{
            background: isDark ? "#0a0a0a" : "#fff",
            padding: "0 24px 0 0",
            height: 64,
            borderBottom: isDark ? "1px solid #262626" : "1px solid #64A70A",
            display: "flex",
            alignItems: "center"
          }}
        >
          <HeaderContent />
        </Header>

        <Content
          style={{
            overflowY: "auto", // Scroll solo aquí
            padding: "24px",
            background: isDark ? "#0a0a0a" : "#f9fafb"
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -15 }}
              transition={{ duration: 0.3 }}
            >
              <Outlet /> {/* Aquí se cargan las páginas como Dashboard */}
            </motion.div>
          </AnimatePresence>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
